import { TranslationClientMessages, ClientMessages } from "../interfaces";

// eslint-disable-next-line import/prefer-default-export
export const messages: TranslationClientMessages = {
  [ClientMessages.activeText]: "Text"
};
